import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"breadcrumb-wrap\"><nav aria-label=\"breadcrumb\"><ol class=\"breadcrumb\"><li class=\"breadcrumb-item\"><a href=\"#/dashboard\" class=\"\"><i class=\"fa fa-home mr-2\"></i> Home </a></li><li class=\"breadcrumb-item\"><a href=\"javascript:void(0)\">July 1</a></li><li class=\"breadcrumb-item active\" aria-current=\"page\"> Billing Information </li></ol></nav></div><div class=\"card\"><h1 class=\"title mb-2\"><i class=\"fa fa-file fa-w-12 mr-1\"></i> Billing Information </h1></div>", 2)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<p><strong>Choose Payment Method</strong></p><div class=\"row\"><div class=\"col-md-4\"><div class=\"iconed-box cursor-pointer selected-box\"><div class=\"round-icon-wrap\"><i class=\"fab fa-cc-stripe\"></i></div><strong>Stripe</strong><div class=\"check-icon-wrap\"><i class=\"fa fa-check-circle\"></i></div></div></div><div class=\"col-md-4\"><div class=\"iconed-box cursor-pointer\"><div class=\"round-icon-wrap\"><i class=\"fab fa-cc-paypal\"></i></div><strong>Paypal</strong><div class=\"check-icon-wrap\"><i class=\"far fa-check-circle\"></i></div></div></div><div class=\"col-md-4\"><div class=\"iconed-box cursor-pointer\"><div class=\"round-icon-wrap\"><i class=\"fab fa-cc-discover\"></i></div><strong>Discover</strong><div class=\"check-icon-wrap\"><i class=\"far fa-check-circle\"></i></div></div></div><div class=\"col-md-4\"><div class=\"iconed-box cursor-pointer\"><div class=\"round-icon-wrap\"><i class=\"fab fa-cc-visa\"></i></div><strong>Visa</strong><div class=\"check-icon-wrap\"><i class=\"far fa-check-circle\"></i></div></div></div></div><hr>", 3)
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Card Payment")
], -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-wrap mt-3" }
const _hoisted_14 = { action: "#" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"form-group\"><label for=\"\">Card Holder*</label><input type=\"text\" class=\"form-control\"></div><div class=\"form-group\"><label for=\"\">Credit/debit card number*</label><input type=\"text\" class=\"form-control\"></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"form-group\"><label for=\"\">Expiration month and year*</label><input type=\"date\" class=\"form-control\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"\">CVC*</label><input type=\"text\" class=\"form-control\"></div></div></div><div class=\"custom-control custom-checkbox\"><input type=\"checkbox\" class=\"custom-control-input\" id=\"customCheck1\"><label class=\"custom-control-label\" for=\"customCheck1\">Save for future use.</label></div>", 4)
const _hoisted_19 = { class: "form-group mt-3" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6\"><div class=\"card-holder hover-check-box mb-3 mt-2 h-lg-100\"><div class=\"text-right card-logo-holder\"><span class=\"card-type-font\">MasterCard</span></div><p><small>Card Number</small></p><div class=\"inline-items mb-3\"><ul><li>XXXX0015</li></ul></div><p><small>Name on Card</small></p><div class=\"row no-gutters\"><div class=\"col-md-8\"><p>Jeewan Thapa</p></div><div class=\"col-md-4\"><div class=\"text-right\"><p>12/27</p></div></div></div></div></div>", 1)
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"shadowed-card\"><p><strong>Promo Code</strong></p><div class=\"form-wrap\"><form action=\"#\"><div class=\"form-group my-2\"><input type=\"text\" class=\"form-control\"></div></form></div></div>", 1)
const _hoisted_23 = { class: "shadowed-card" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Order Summary")
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "SubTotal")
  ])
], -1)
const _hoisted_28 = { class: "col-6 text-right" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 0,
  class: "col-6"
}
const _hoisted_32 = {
  key: 1,
  class: "col-6 text-right"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("p", null, "$223", -1)
const _hoisted_34 = {
  key: 2,
  class: "col-6"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Discount")
], -1)
const _hoisted_36 = {
  key: 3,
  class: "col-6 text-right"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("p", null, "$223", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "row"
}
const _hoisted_40 = { class: "col-6" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Total")
const _hoisted_42 = { class: "col-6 text-right" }
const _hoisted_43 = { class: "form-group mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_big = _resolveComponent("big")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.error.errorList.billingErrors,
        hasError: _ctx.state.ui.error.hasError
      }, null, 8, ["errors", "hasError"]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("form", _hoisted_14, [
                    _hoisted_15,
                    _createVNode("div", _hoisted_19, [
                      _createVNode("button", {
                        type: "submit",
                        class: "btn default-btn d-inline-block",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.paymentSuccess && _ctx.paymentSuccess(...args)))
                      }, " Confirm Payment ")
                    ])
                  ])
                ])
              ]),
              _hoisted_20
            ])
          ])
        ]),
        _createVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode("div", _hoisted_23, [
            _hoisted_24,
            _hoisted_25,
            _createVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode("div", _hoisted_28, [
                (_ctx.state.invoice.subTotal)
                  ? (_openBlock(), _createBlock("p", _hoisted_29, "$" + _toDisplayString(_ctx.state.invoice.subTotal), 1))
                  : (_openBlock(), _createBlock("p", _hoisted_30, "$0.00"))
              ]),
              (_ctx.state.invoice.tax)
                ? (_openBlock(), _createBlock("div", _hoisted_31, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, "Tax (" + _toDisplayString(_ctx.state.invoice.tax) + "%)", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.invoice.tax)
                ? (_openBlock(), _createBlock("div", _hoisted_32, [
                    _hoisted_33
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.invoice.discount)
                ? (_openBlock(), _createBlock("div", _hoisted_34, [
                    _hoisted_35
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.invoice.discount)
                ? (_openBlock(), _createBlock("div", _hoisted_36, [
                    _hoisted_37
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_38,
            (_ctx.state.invoice.amount)
              ? (_openBlock(), _createBlock("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, [
                        _createVNode(_component_big, null, {
                          default: _withCtx(() => [
                            _hoisted_41
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_42, [
                    _createVNode("p", null, "$" + _toDisplayString(_ctx.state.invoice.amount), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_43, [
              _createVNode("button", {
                type: "submit",
                class: "btn default-btn d-block w-100",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmPayment && _ctx.confirmPayment(...args))),
                disabled: _ctx.state.ui.isPostLoading.confirmPayment
              }, _toDisplayString(_ctx.state.ui.isPostLoading.confirmPayment ? 'Loading...' : 'Confirm Payment'), 9, ["disabled"])
            ])
          ])
        ])
      ])
    ])
  ]))
}